module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"start":{"partner_products":{"button":"Alle Produkte entdecken","description":"Diese Produkte werden unter \\"Fonds-Mediathek\\" regelmäßig mit vertiefenden Informationen und Updates ergänzt","title":"Produkte mit Fonds-Mediathek"}}}}}}')
  delete Component.options._Ctor
}
